module.exports = {
    system: {
        userManage: 'User Administration',
        productManage: 'Product Management',
        labelField: 'Label field',
        versionManage: 'Firmware Version',
        updateStatus: 'Update Status',
        system: 'System',
        operate: 'Operation',
        add: 'Add',
        edit: 'Modify',
        del: 'Delete',
        sure: 'OK',
        cancel: 'Cancel',
        details: 'Update details',
        submiting: 'Submiting...',
        productTab: {
            search: 'Search',
            download: 'Download',
            import: 'Import',
            importTip: {
                success: 'Imported successfully, {success} successful!',
                fail: 'Import failed',
                excel: 'The suffix name of the import file must be xlsx or xls!',
                format: 'File format is incorrect',
                parseFail: 'File parsing failed',
                permission: 'You don\'t have permission to import items',
                chooseFile: 'Select the file',
                uploadFile: 'Upload files：',
                chooseStore: 'Choose a store：',
                findStore: 'Find a store',
                notEmpty: 'Upload file cannot be empty',
                notStore: 'Please select a store',
                getStoreInfoFail: 'Failed to query store information',
                getUpdateInfoFail: 'Failed to query update status',
                getUpdateInfoDetailFail: 'Query update details failed',
                processing:'Please wait for the last product import processing to be completed'
            },
            addTip: {
                success: 'Add product successfully',
                exist: 'The product already exist',
                fail: 'Adding the product failed',
                permission: 'You do not have permission to add the product'
            },
            editTip: {
                success: 'Modify product successfully',
                exist: 'The product dose not exist',
                fail: 'Modifying the product failed',
                permission: 'You do not have permission to modify the product'
            },
            delTip: {
                success: 'Delete product successfully',
                exist: 'The product dose not exist',
                fail: 'Deleting the product failed',
                msg: 'Are you sure you want to delete the product with ID {id}?',
                delSelect: 'Are you sure you want to delete the selected item?',
                delSelectFirst: 'Please select the item you want to delete first!',
                permission: 'You do not have permission to delete the product'
            },
            productAttr: {
                num: 'Number',
                productNo: 'Product number',
                productName: 'Product name',
                proAbbr: 'Product name abbreviation',
                price: 'Price',
                brand: 'Brand',
                origin: 'Place of origin',
                specification: 'Specification',
                rating: 'Grade',
                piece: 'Unit',
                qrcode: 'QR code',
                barcode: 'Barcode',
                supplierName: 'Supplier name'
            },
            tips: {
                title: 'prompt',
                addTip: 'Added product data will be added to each store at the same time.',
                editTip: 'This action will also modify the same product data for each store.',
                delTip: 'This will also delete the same product data for each store.',
                importTip: 'Imported product data will be added to each store at the same time.',
                downTip: 'Import data using the template file format downloaded here.'
            }
        },
        userTab: {
            edit: 'Modify',
            del: 'Delete',
            addTip: {
                success: 'Add user successfully',
                exist: 'The user already exist',
                fail: 'Adding the user failed',
                permission: 'You do not have permission to add users'
            },
            editTip: {
                success: 'Modify user successfully',
                exist: 'The user dose not exist',
                fail: 'Modifying the user failed',
                permission: 'You do not have permission to modify users'
            },
            delTip: {
                success: 'Delete user successfully',
                exist: 'The user dose not exist',
                fail: 'Deleting the user failed',
                msg: 'Are you sure you want to delete {userName}?',
                permission: 'You do not have permission to delete users'
            },
            userAttr: {
                userNo: 'User Number',
                userName: 'Username',
                nickName: 'Name',
                password: 'Password',
                isValid: 'Status',
                validOpt: [{
                    label: 'Valid',
                    value: true
                }, {
                    label: 'Invalid',
                    value: false
                }],
                // istype: 'Price Tag Type',
                // type: [{
                //     label: 'Gateway version',
                //     value: 0
                // }, {
                //     label: 'Mobile version',
                //     value: 1
                // }]
            }
        },
        labelTab: {
            labelTitle: 'ESL prefix editing',
            field: 'Field Id',
            idName: 'Product Name',
            eslPrefix: 'ESL Prefix',
            proNo: 'Product Number:',
            name: 'Product name:',
            proAbbr: 'Product name Abbreviation:',
            price: 'Price:',
            brand: 'Brand:',
            specification: 'Specification:',
            rating: 'Grade:',
            piece: 'Unit:',
            origin: 'Place of Origin:',
            supplierName: 'Supplier:',
            switch: 'Chinese/English',
            save: 'save',
            labelTip: {
                save: 'save',
                msg: 'Determine the modified ESL field prefix?',
                success: 'Modify the ESL field prefix successfully.',
                fail: 'Modify ESL field prefix failed'
            },
            title: 'prompt',
            tip: 'This function implements the ESL prefix editing. After the modification is saved, the ESL needs to be updated, and the corresponding electronic ESL can take effect.'
        },
        versionTab: {
            label: 'label',
            gateway: 'gateway',
            uploadESL: 'Upload',
            uploadGwWifi: 'Upload WiFi firmware',
            uploadGwBle: 'Upload Ble firmware',
            tips: {
                title: 'prompt',
                uploadESLTip: 'The uploaded ESL firmware will upgrade the firmware of all store ESL.',
                uploadGwWifiTip: 'The uploaded WiFi firmware will upgrade the WiFi firmware of all store gateways.',
                uploadGwBleTip: 'The uploaded Ble firmware will upgrade the Ble firmware of all store gateways.'
            },
            gwUpgradeLogs: {
                num: 'Number',
                codeName: 'Program name',
                uploadTime: 'Upload time',
                versionNum: 'Version number',
                type: 'Type'
            },
            gwWifiUpgradeTips: {
                format: 'The uploaded firmware can only be a bin file with the correct format.',
                loading: 'Gateway WiFi firmware upload...',
                success: 'Gateway WiFi firmware uploaded successfully',
                fail: 'Gateway WiFi firmware upload failed'
            },
            gwBleUpgradeTips: {
                format: 'The uploaded firmware can only be a zip file with the correct format.',
                loading: 'Gateway Bluetooth firmware upload...',
                success: 'Gateway Ble firmware uploaded successfully',
                fail: 'Gateway Ble firmware upload failed'
            },
            gwDelTips: {
                msg: 'Are you sure you want to delete {packageName}?',
                success: 'Successfully deleted',
                fail: 'Failed to delete',
            },
            table1: {
                index: 'Number',
                name: 'Program name',
                uploadTime: 'Upload time',
                version: 'Version number',
                type: 'Type',
                format: 'The uploaded firmware can only be a bin file with the correct format.',
                loading: 'ESL firmware upload...',
                success: 'The ESL firmware was uploaded successfully',
                fail: 'The ESL firmware was uploaded failed',
                queryFailInfo: 'Querying the ESL firmware version information failed',
                del: 'delete',
                msg: 'Are you sure you want to delete the {version} version label firmware upgrade package?',
                upgradeSuccess: 'Remove the ESL firmware upgrade package successfully',
                upgradeFail: 'Remove the ESL firmware upgrade package failed'
            }
        },
        updateTab: {
            rePush: 'One-click Repost',
            num: 'Number',
            fileName: 'File name',
            importTime: 'Import time',
            tip: {
                title: 'Update details',
                tip: 'prompt',
                getUpdateStatusFail: 'Failed to query update status',
                getUpdateStatusDetailFail: 'Query update details failed',
                rePushTip: 'One-click re-push will re-push the stores that failed to update in the newly imported data',
                msg: 'Are you sure to re-push the store that failed to update?',
                rePushSuccess: 'The one-click re-push instruction is sent successfully, please refresh the page later to get the latest data!',
                rePushFail: 'Failed to send one-key push command',
                wait: 'Please wait for the last system import or one-click re-push processing to complete'
            },
            table: {
                storeId: 'StoreID',
                storeName: 'Store name',
                currentStatus: 'Current state',
                successNumber: 'Number of successes',
                failedNumber: 'Number of failures',
                total: 'Total'
            },
            format: {
                status: [{
                    key: 0,
                    value: 'Pending upgrade'
                },{
                    key: 1,
                    value: 'Updating'
                },{
                    key: 2,
                    value: 'Updated'
                },{
                    key: 3,
                    value: 'Gateway abnormal'
                }]
            }
        },
        prefix: { //获取标签前缀
            fail: 'Failed to get the label prefix'
        },
        validMsg: {
            user: {
                userName: 'Please enter username',
                nameValid: 'Please enter numbers or letters',
                nameExist: 'The user already exist',
                nameFail: 'Failed to get, please re-enter',
                // nameLen:'长度不能超过20个字符',
                nickName: 'Please enter name',
                isValid: 'Please select a option',
                password: 'Please enter password',
                length1: 'Please enter password between 6 and 20 characters',
                passRule: 'The password can not contain space',
                passRule1: 'The password can not contain chinese'
            },
            pro: {
                productName: 'Please enter product name',
                nameLen: 'The name must be less than 20 characters',
                // priceRule:'Please enter the valid format, up to two decimal places',
                priceRule1: 'Please enter the correct format',
                priceRule2: 'Please enter up to two decimal places',
                barcode: 'Please enter ID',
                // barcodeValid:'请输入合法的ean13条形码',
                barcodeValid: 'Please enter 13 digits',
                barcodeExist: 'The product already exist',
                barcodeFail: 'Failed to get, please re-enter',
                proNoRule: 'Please enter numbers or letters'
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/system.js